import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  > svg {
    color: #00efff;
    min-height: 14px;
    min-width: 14px;
    cursor: pointer;
  }
`;

export const TooltipContainer = styled.div`
  position: absolute;
  right: 26px;
  top: 50%;
  transform: translateY(-50%);
  background: #00ffff;
  padding: 8px;
  border-radius: 4px;
  width: max-content;
  max-width: 280px;
`;
